function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Support-Panel",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "02-Dashboard---COULDNT-FIND",
  transform: "translate(-865.000000, -713.000000)"
}, React.createElement("g", {
  id: "3.-Icons/8.Preference/Done-Copy-5",
  transform: "translate(806.000000, 622.000000)"
}, React.createElement("g", {
  id: "ic_report-copy"
}, React.createElement("g", {
  id: "Group-30",
  transform: "translate(24.000000, 0.000000)"
}, React.createElement("g", {
  id: "Group-25",
  transform: "translate(30.000000, 19.000000)"
}, React.createElement("g", {
  id: "1.-Elements/2.-Mail/7.-inline-Pop",
  transform: "translate(118.500000, 55.000000) rotate(-90.000000) translate(-118.500000, -55.000000) translate(64.000000, -63.000000)"
}, React.createElement("g", {
  id: "Group-7",
  transform: "translate(54.500000, 118.000000) rotate(90.000000) translate(-54.500000, -118.000000) translate(-63.000000, 64.000000)"
}, React.createElement("g", {
  id: "3.-Icons/8.Preference/Done-Copy-4",
  transform: "translate(0.000000, 67.000000)"
}, React.createElement("g", {
  id: "ic_report-copy"
}, React.createElement("g", {
  id: "Icon-24px"
}, React.createElement("polygon", {
  id: "Shape",
  points: "0 0 24 0 24 24 0 24"
}), React.createElement("g", {
  id: "Group-31",
  transform: "translate(4.000000, 4.000000)"
}, React.createElement("path", {
  d: "M5.57874559,0 C5.08483671,0 4.40543977,0.279004678 4.05267942,0.631765021 L0.631765021,4.05267942 C0.282850835,4.40159361 0,5.07939224 0,5.57874559 L0,10.4212544 C0,10.9151633 0.279004678,11.5945602 0.631765021,11.9473206 L4.05267942,15.368235 C4.40159361,15.7171492 5.07939224,16 5.57874559,16 L10.4212544,16 C10.9151633,16 11.5945602,15.7209953 11.9473206,15.368235 L15.368235,11.9473206 C15.7171492,11.5984064 16,10.9206078 16,10.4212544 L16,5.57874559 C16,5.08483671 15.7209953,4.40543977 15.368235,4.05267942 L11.9473206,0.631765021 C11.5984064,0.282850835 10.9206078,0 10.4212544,0 L5.57874559,0 Z",
  id: "Path",
  fill: "#BDBDBD"
}), React.createElement("text", {
  id: "?",
  fontFamily: "SFProText-Regular, SF Pro Text",
  fontSize: 12,
  fontWeight: "normal",
  fill: "#FFFFFF"
}, React.createElement("tspan", {
  x: 5,
  y: 12
}, "?"))))))))))))));

var SvgNoresponse = function SvgNoresponse(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNoresponse, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/noresponse.006e89da.svg";
export { ForwardRef as ReactComponent };